// extracted by mini-css-extract-plugin
export var addButton = "_fb-0";
export var border = "_fb-8";
export var check = "_fb-h";
export var danger = "_fb-6";
export var dropdownContainer = "_fb-1";
export var editModalBody = "_fb-j";
export var footerContainer = "_fb-i";
export var fullWidth = "_fb-a";
export var hide = "_fb-9";
export var icon = "_fb-3";
export var input = "_fb-7";
export var inputFlex = "_fb-b";
export var inputWrapper = "_fb-c";
export var manualFocus = "_fb-5";
export var optionButton = "_fb-4";
export var pillWrapper = "_fb-e";
export var pointer = "_fb-2";
export var showOverflow = "_fb-f";
export var tagsFlex = "_fb-d";
export var xButton = "_fb-g";